import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

export interface BeaconData {
  mac?: string;
  major?: number|null;
  minor?: number|null;
  name?: string;
}

export interface BeaconLocalData {
  mac?: string;
  major?: number|null;
  minor?: number|null;
  name?: string;
  beaconId?: string;
  rssi?: number|null;
  state?: string|null;
  floorCode?: string|null;
  roomCode?: string|null;
}

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  constructor() { }

  /**
   * Set a preference value by key
   */
  async set(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  }

  /**
   * Get a stored preference value
   */
  async get(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    return value;
  }

  /**
   * Remove a preference by key
   */
  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }

  /**
   * Clear all stored preferences
   */
  async clear(): Promise<void> {
    // The permission onboarding flag is per device, so it must survive logout / session resets
    const skipPermission = await this.get('SKIP_PERMISSION');
    await Preferences.clear();
    if (skipPermission != null) {
      await this.set('SKIP_PERMISSION', skipPermission);
    }
  }

  async setUserLogged(): Promise<void> {
    await this.set('LOGGED', 'true');
  }

  async getUserLogged(): Promise<boolean> {
    const data = await this.get('LOGGED');
    if(data != null && data == 'true') return true;
    return false;
  }

  async setLastActive(): Promise<void> {
    await this.set('LAST_ACTIVE', Date.now().toString());
  }

  async getLastActive(): Promise<Number> {
    const saved = await this.get('LAST_ACTIVE');
    if (saved) {
        return parseInt(saved);
    }
    return Date.now();
  }

  async setCurrentBeacon(data: BeaconData | null): Promise<void> {
    const current = await this.get('CURRENT_BEACON');
    if(current){
      await this.set('PREV_BEACON', current);
    }
    if(data != null){
      const str = JSON.stringify(data);
      await this.set('CURRENT_BEACON', str);
    } else{
      await this.remove('CURRENT_BEACON');
    }
    
  }

  async getCurrentBeacon(): Promise<BeaconData | null> {
    const data = await this.get('CURRENT_BEACON');
    if(data){
      const beacon: BeaconData = JSON.parse(data);
      return beacon;
    }
    return null;
  }

  async setCurrentBeaconLocalData(data: BeaconLocalData | null): Promise<void> {
    if(data != null){
      const str = JSON.stringify(data);
      await this.set('CURRENT_BEACON_LOCAL', str);
    }
  }

  async getCurrentBeaconLocalData(): Promise<BeaconLocalData | null> {
    console.log("getCurrentBeaconLocalData");
    const data = await this.get('CURRENT_BEACON_LOCAL');
    if(data){
      const beacon: BeaconLocalData = JSON.parse(data);
      return beacon;
    }
    return null;
  }

  async setSkipPermission(): Promise<void> {
    await this.set('SKIP_PERMISSION', 'true');
  }

  async getSkipPermission(): Promise<boolean> {
    const data = await this.get('SKIP_PERMISSION');
    if(data != null && data == 'true') return true;
    return false;
  }
}
